module.exports = __webpack_public_path__ + "media/tiger_win.bdba8034.mp3";